<template>
    <div>
        <base-dialog :show-dialog="showDialog">
            <template v-slot:body>
                <v-card dark>
                    <!-- <v-card-title>
                        Excluir Orçamento
                    </v-card-title> -->
                    <v-card-text>
                        <div class="warning rounded-lg px-2 py-2">
                            <span class="text-subtitle-1 white--text font-weight-regular">
                                Ao confirmar 
                                este orçamento será deletado e não será possível recuperá-lo posteriormente.</span>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            small
                            color="blue"
                            @click="$emit('close-dialog')">
                            <span class="text-button font-weight-regular">Voltar</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            small
                            color="red"
                            @click="$emit('delete-order')"
                        >
                            <span class="text-button font-weight-regular">Confirmar</span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </base-dialog>
    </div>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog';
export default {
    components:{ BaseDialog },
    props:{
        showDialog : { 
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>

</style>